export enum Service {
  NavigationOverlay = 'navigation-overlay',
  Overlay = 'overlay',
  ScrollBlocking = 'scroll-blocking',
  PageLoad = 'page-load',
  IdGenerator = 'id-generator',
}
